import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { useAuth, useProtectedPage } from '../../../context/AuthContext'
import callAPI from '../../../helpers/callAPI'
import Advertiser from '../../../templates/Advertiser/Advertiser'
import Campaign from '../../../templates/Campaign/Campaign'
import ReportTable from '../../../templates/ReportTable/ReportTable'
import Loading from '../../../templates/UI/Loading/Loading'
import EditCampaignPhase from '../../Dashboard/components/CampaignsInSetup/EditCampaignPhase/EditCampaignPhase'
import useCallApi from '../../../hooks/useCallApi'
import CampaignSetupContent from '../../../components/CampaignSetupContent/CampaignSetupContent'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import useUrlState from '../../../hooks/useUrlState'

const WorksheetReport = ({ showSystemMessage }) => {

    document.title = 'Campaign Worksheet Report'

    const auth = useAuth()
    useProtectedPage(auth.permissions, 'campaign_worksheet_report')

    const { data: phaseData, dataLoaded: phaseDataLoaded, refetch: phaseDataRefetch } = useCallApi('campaigns/phases', 'GET', {}, [], showSystemMessage)
    // const [filters, setFilters] = useState({ phase: 'All', manager: (auth.user.role === 'BIZDEV' || auth.user.role === 'BIZDEV_DIRECTOR') ?  'BD' : 'AAM' })
    const [dataLoaded, setDataLoaded] = useState(false)
    const [report, setReport] = useState([])
    const [campaignPhaseData, setCampaignPhaseData] = useState()
    const [showCampaignPhaseModal, setShowCampaignPhaseModal] = useState(false)
    const [phase, setPhase] = useUrlState('ph', 'All')
    const [manager, setManager] = useUrlState('m', 'ALL')


    useEffect(() => {
        getReport()
    }, [phase, manager])

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'ID',
                accessor: 'offer_id',
            },
            {
                Header: 'Campaign',
                accessor: 'offer_name',
                Cell: (tableData) => {
                    return <Campaign oid={tableData.data[tableData.row.index].offer_id} name={tableData.data[tableData.row.index].offer_name} />
                },
            },
            {
                Header: 'Status',
                accessor: 'status',
                Cell: (tableData) => {
                    return <div>{tableData.data[tableData.row.index].status}</div>
                },
            },
            {
                Header: 'Advertiser',
                accessor: 'merchant_name',
                Cell: (tableData) => {
                    return <Advertiser id={tableData.data[tableData.row.index].merchant_id} name={tableData.data[tableData.row.index].merchant_name} />
                },
            },
            {
                Header: 'Advertiser Manager',
                accessor: 'full_name',
            },
            {
                Header: 'Started',
                accessor: 'db_date',
                Cell: ({ cell: { value } }) => {
                    return <div style={{ minWidth: '100px' }}>{value ? moment(value).format('YYYY-MM-DD') : ''}</div>
                },
            },
            {
                Header: 'Last Updated',
                accessor: 'notes_date',
                Cell: ({ cell: { value } }) => {
                    return <div style={{ minWidth: '100px' }}>{value ? moment(value).format('YYYY-MM-DD') : ''}</div>
                },
            },
            {
                Header: 'Notes',
                accessor: 'notes',
                className: 'mw-50',
                Cell: ({ cell: { value } }) => {
                    return (
                        <div style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            wordBreak: 'break-word'
                        }}>
                            {value}
                        </div>
                    )
                }
            },
            {
                Header: 'Phase',
                accessor: 'phase_sorting',
                Cell: (tableData) => {
                    return (
                        <Link className="btn btn-warning btn-sm" to={`/advertiser/${tableData.data[tableData.row.index].merchant_id}/campaignSetup?id=${tableData.data[tableData.row.index].offer_id}`} variant="primary" size="sm"
                            onClick={(e) => {
                                e.preventDefault();
                                setCampaignPhaseData(tableData.data[tableData.row.index]);
                                setShowCampaignPhaseModal(true);
                            }}
                            style={{ whiteSpace: 'nowrap' }}>
                            {tableData.data[tableData.row.index].phase_name}
                        </Link>
                    )
                },
            },
        ]

        return (
            <React.Fragment>
                <ReportTable data={report} columns={columns} />
            </React.Fragment>
        )
    }

    const getReport = () => {
        setDataLoaded(false)

        let url = 'campaigns/worksheetReport?ph=' + phase + '&m=' + manager;

        callAPI(url, 'GET')
            .then((result) => {
                if (result['success'] === true) {
                    setReport(result.data)
                } else if (result['success'] === false) {
                    showSystemMessage('error', result.errors.message)
                }

                setDataLoaded(true)
            })
            .catch((error) => {
                console.log(`Error while fetching top campaigns: ${error}`)
                showSystemMessage('error', 'An error occurred while fetching top campaigns')
            })
    }

    return (
        <div>
            <Modal show={showCampaignPhaseModal} onHide={() => { setShowCampaignPhaseModal(false); getReport() }} size="xl">
                <CampaignSetupContent modal refetch={getReport} showSystemMessage={showSystemMessage} campaignPhaseData={campaignPhaseData} closeModal={() => { setShowCampaignPhaseModal(false) }} />
            </Modal>
            <div className="card">
                <div className="card-body p-0">
                    <div className="d-flex p-3">
                        <div className="mr-4 d-flex align-items-center">
                            <h1 className="mb-h1-dark">Campaign Worksheet Report</h1>
                            <div className="ml-3">
                                <select className="form-control form-control-sm"
                                    onChange={(e) => setPhase(e.target.value)}
                                    value={phase}>
                                    <option value="All">All In-Progress</option>
                                    {phaseDataLoaded && phaseData.data.map((phase, index) => (
                                        <option key={index} value={phase.phase_id}>{phase.phase_name}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="ml-3">
                                <select className="form-control form-control-sm"
                                    onChange={(e) => {
                                        // Convert empty string to null
                                        setManager(e.target.value === "" ? null : e.target.value);
                                    }}
                                    defaultValue={manager}>
                                    <option value="ALL">All</option>
                                    <option value="BD">Bizdev</option>
                                    <option value="AAM">Advertiser Managers</option>

                                </select>
                            </div>

                        </div>
                    </div>
                    {dataLoaded ? report.length === 0 ? <div className="p-3">No stats for the current parameters.</div> : getReportOutput() : <Loading />}
                </div>
            </div>
        </div>
    )
}

export default WorksheetReport
